<button
  mat-icon-button
  type="button"
  title="back button"
  class="app-menu-button back-button"
  oPlayId
  pidValue="back-btn"
  (click)="back()">
  <mat-icon svgIcon="arrow-left" />
</button>
